<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="seal-motor-oil-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="seal-motor-oil-search-view-table"
      @select="$emit('select', $event.data as Seal_Motor_Oil)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useSealMotorOils } from "@/composables/equipment/sealMotorOils/sealMotorOils";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Seal_Motor_Oil } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Seal_Motor_Oil): void;
}>();

const sealmotoroilsearch = useSealMotorOils(props.isAdmin);

provide("equipment", sealmotoroilsearch);
</script>
